/* This example requires Tailwind CSS v2.0+ */
import { Fragment, useState } from 'react';
import { Dialog, Transition, Menu } from '@headlessui/react';
import {
  CheckCircleIcon,
  DuplicateIcon,
  PencilAltIcon,
  TrashIcon,
  XIcon,
} from '@heroicons/react/solid';
import TwitterBirdIcon from '../Icons/twitter';

import TextareaAutosize from 'react-textarea-autosize';

import { Switch } from '@headlessui/react';
import MediumLogo from '../Icons/medium';
import Button from '../Button';
import LinkedInLogo from '../Icons/linkedin';
import { useLayoutEffect } from 'react';
import ThreadPreview from '../Publishing/Twitter/ThreadPreview';

import firebase from 'firebase/app';
import 'firebase/auth';
import 'firebase/database';

import { useEffect } from 'react';
import { Tooltip } from 'react-tippy';
import AlertBanner from '../Alert';

import { motion } from 'framer-motion';
import SpinnerIcon from '../Icons/spinner';
import LinkedinPostPreview from '../Publishing/Linkedin/PostPreview';
import { useRouter } from 'next/router';
import MediumStoryPreview from '../Publishing/Medium/StoryPreview';
import Link from 'next/link';
import {
  FolderAddIcon,
  LinkIcon,
  PencilIcon,
  MinusIcon,
  PlusIcon,
  ExclamationIcon,
} from '@heroicons/react/outline';
import AddToCollection from '../Modal/AddToCollection';
import ButtonTip from '../Tooltip/ButtonTip';
import {
  formatThread,
  scheduleEssayImage,
  tweetScheduledThread,
  validateImage,
} from '../../utils/publishing/twitter';
import { publishToTypeshare } from '../../utils/publishing/typeshare';
import { scheduleMediumPost } from '../../utils/publishing/medium';
import { scheduleLinkedinPost } from '../../utils/publishing/linkedin';
import { useRef } from 'react';
import { typeshareToast } from '../Toast/typeshareToast';
import { client } from '../../utils/http';

function classNames(...classes) {
  return classes.filter(Boolean).join(' ');
}

export default function PeakPost({
  open,
  setOpen,
  userID,
  postID,
  activeSlotPretty,
  activeSlotUnix,
  slug,
  productName,
  refreshQueue,
}) {
  const router = useRouter();

  const [enabled, setEnabled] = useState(false);

  const [scheduling, setScheduling] = useState(false);

  const [hasCustomTweetText, setHasCustomTweetText] = useState(false);
  const [tweetText, setTweetText] = useState('');

  const [linkedinText, setLinkedinText] = useState('');

  const [linkedinEnabled, setLinkedinEnabled] = useState(false);
  const [mediumEnabled, setMediumEnabled] = useState(false);

  const [imageLoading, setImageLoading] = useState(false);

  const [headline, setHeadline] = useState('');
  const [subtitle, setSubtitle] = useState('');
  const [postSlug, setPostSlug] = useState('');

  const [altText, setAltText] = useState(null);

  const [hasCustomSlug, setHasCustomSlug] = useState(null);

  const [imageNeedsRefresh, setImageNeedsRefresh] = useState(false);

  const [twitterEditorText, setTwitterEditorText] = useState('');

  const [twitterUser, setTwitterUser] = useState('');
  const [linkedBefore, setLinkedBefore] = useState(false);

  //user meta
  const [twitterHandle, setTwitterHandle] = useState('');
  const [twitterName, setTwitterName] = useState('');
  const [twitterPhoto, setTwitterPhoto] = useState('/sams.jpeg');

  const [twitterType, setTwitterType] = useState('image');

  const [hasError, setHasError] = useState(false);
  const [imageError, setImageError] = useState(false);

  const [mediumHTML, setMediumHTML] = useState('');
  const [linkedinHTML, setLinkedinHTML] = useState('');

  const [hasMedium, setHasMedium] = useState(false);
  const [mediumProfile, setMediumProfile] = useState('');

  const [hasLinkedin, setHasLinkedin] = useState(false);
  const [linkedinProfile, setLinkedinProfile] = useState('');
  const [linkedinExpired, setLinkedinExpired] = useState(false);

  const [attachLink, setAttachLink] = useState(false);

  const [addToCollectionModal, setAddToCollectionModal] = useState(false);
  const [selectedCollection, setSelectedCollection] = useState(null);

  const [rawTweetArray, setRawTweetArray] = useState([]);
  const [imageIDArray, setImageIDArray] = useState([]);
  const [imageDataArray, setImageDataArray] = useState([]);
  const [twitterThreadText, setTwitterThreadText] = useState('');

  const [errorMSG, setErrorMSG] = useState(null);
  const [twitterError, setTwitterError] = useState(false);
  const [typeshareError, setTypeshareError] = useState(false);

  const [threadMeta, setThreadMeta] = useState(null);

  const [socialBlogSuccess, setSocialBlogSuccess] = useState(false);
  const [twitterSuccess, setTwitterSuccess] = useState(false);
  const [mediumSuccess, setMediumSuccess] = useState(false);
  const [linkedinSuccess, setLinkedinSuccess] = useState(false);

  const [hasCustomLinkedinText, setHasCustomLinkedinText] = useState(false);

  const [twitterSecret, setTwitterSecret] = useState(null);
  const [twitterToken, setTwitterToken] = useState(null);

  const [twitterSize, setTwitterSize] = useState(null);
  const [height, setHeight] = useState(0);

  const imageContainer = useRef(null);

  const [essayImage, setEssayImage] = useState(null);

  const scheduledToast = ({ headline }) => {
    typeshareToast({
      title: 'Added to Queue',
      text: headline ? headline : 'Post',
      secondaryText: 'added to Queue.',
      type: 'cta',
      href: `/${encodeURIComponent(
        slug ? slug : '',
      )}/posts/${encodeURIComponent(
        postSlug ? postSlug : postID ? postID : '',
      )}`,
    });
  };

  useEffect(() => {
    if (height) {
      //~ .69 aspect ratio (width / height)
      if (height > 593) {
        setTwitterSize('Too big');
      } else {
        setTwitterSize('Perfect');
      }
    }
  }, [height]);

  useEffect(() => {
    if (essayImage) {
      setTimeout(() => {
        {
          imageContainer.current
            ? setHeight(imageContainer.current.clientHeight)
            : null;
        }
      }, 100);
    }
  }, [essayImage]);

  useEffect(() => {
    if (userID && postID) {
      getEditorContent();
    }
  }, [userID, postID]);

  useEffect(() => {
    if (userID && postID) {
      getUserTwitterMeta();
    }
  }, [userID, postID]);

  const getEditorContent = () => {
    //TODO: Handle custom text

    const db = firebase.database();
    const ref = db.ref(`users/${userID}/typeshares`).child(postID);
    ref.once('value', function (snapshot) {
      if (snapshot.hasChild('content/bodyText')) {
        //TODO: only get subtitle if there is no custom subtitle

        if (snapshot.hasChild('content/mediumText')) {
          setMediumHTML(snapshot.child('content/mediumText').val());
        } else {
          setMediumHTML(snapshot.child('content/bodyText').val());
        }

        if (snapshot.hasChild('content/linkedinText')) {
          setHasCustomLinkedinText(true);
          setLinkedinHTML(snapshot.child('content/linkedinText').val());
        } else {
          setHasCustomLinkedinText(false);
          setLinkedinHTML(snapshot.child('content/bodyText').val());
        }

        if (snapshot.hasChild('content/twitterText')) {
          setTwitterEditorText(snapshot.child('content/twitterText').val());
        } else {
          setTwitterEditorText(snapshot.val().content.bodyText);
        }
      }
      if (snapshot.hasChild('content/titleText')) {
        setHeadline(snapshot.val().content.titleText);
      }
      if (snapshot.hasChild('settings/twitterFormat')) {
        setTwitterType(snapshot.val().settings.twitterFormat);
      } else {
        setTwitterType('image');
      }

      if (snapshot.hasChild('preview/slug')) {
        if (snapshot.val().preview.slug) {
          if (snapshot.hasChild('settings/twitterFormat')) {
            var form = snapshot.val().settings.twitterFormat;
            if (form === 'thread') {
              setPostSlug(postID);
            } else {
              setPostSlug(snapshot.val().preview.slug);
              setHasCustomSlug(true);
            }
          } else {
            setPostSlug(snapshot.val().preview.slug);
            setHasCustomSlug(true);
          }
        } else {
          setPostSlug(postID);
        }
      } else {
        if (snapshot.hasChild('content/titleText')) {
          if (snapshot.hasChild('settings/twitterFormat')) {
            var form = snapshot.val().settings.twitterFormat;
            if (form === 'thread') {
              setPostSlug(postID);
            } else {
              if (snapshot.val().content.titleText) {
                generateSlug(snapshot.val().content.titleText);
              } else {
                setPostSlug(postID);
              }
            }
          } else {
            if (snapshot.val().content.titleText) {
              generateSlug(snapshot.val().content.titleText);
            } else {
              setPostSlug(postID);
            }
          }
        } else {
          setPostSlug(postID);
        }

        setHasCustomSlug(false);
      }
      if (snapshot.hasChild('preview/subtitle')) {
        setSubtitle(snapshot.val().preview.subtitle);
      } else {
        getSubtitle(snapshot.child('content/bodyText').val());
      }

      if (snapshot.hasChild('preview/tweetText')) {
        setTweetText(snapshot.val().preview.tweetText);
        setHasCustomTweetText(true);
      } else {
        setHasCustomTweetText(false);
      }
    });
  };

  function getUserTwitterMeta() {
    const ref = firebase.database().ref('users/' + userID + '/meta/twitter');
    ref.once(
      'value',
      function (snapshot) {
        if (snapshot.exists()) {
          if (snapshot.val().photo === undefined) {
            router.push('/');
          } else {
            //has twitter in db
            if (snapshot.val().newTwitterApp === true) {
              //connected with new token, all good
              setTwitterUser(true);
              setLinkedBefore(false);
              setEnabled(true);
            } else {
              //get the auth providers of the current user
              const providers = firebase.auth().currentUser.providerData;

              //check if the user has connected with twitter
              const twitterConnected = providers.some(function (provider) {
                return provider.providerId === 'twitter.com';
              });

              if (twitterConnected) {
                //user has connected with twitter
                setTwitterUser(false);
                setLinkedBefore(true);
                setEnabled(false);
              } else {
                //user has not connected with twitter
                setTwitterUser(false);
                setLinkedBefore(false);
                setEnabled(false);
              }
            }

            //snapshot.hasChild("blocked") ? setBlocked(true) : setBlocked(false)

            setTwitterPhoto(snapshot.val().photo);
            setTwitterName(snapshot.val().displayName);
            setTwitterHandle(snapshot.val().handle);
            setTwitterSecret(snapshot.val().secret);
            setTwitterToken(snapshot.val().token);
          }
        } else {
          //Cant share to Twitter, so dont show that part in the publish modal
          setTwitterUser(false);
          setEnabled(false);
        }
      },
      function (errorObject) {},
    );
  }

  useEffect(() => {
    if (hasCustomSlug === false && twitterType !== 'thread') {
      var generateSlug = safeSlug(headline);
      setPostSlug(generateSlug);
    }
  }, [headline, hasCustomSlug]);

  useEffect(() => {
    if (!hasCustomTweetText) {
      setTweetText(headline);
    }
  }, [headline, hasCustomTweetText]);

  useEffect(() => {
    if (slug && userID && postID) {
      generateIMG();
    }
  }, [slug, userID, postID]);

  const generateIMG = async () => {
    setImageLoading(true);

    const domain =
      process.env.NEXT_PUBLIC_APP_ENV === 'production'
        ? 'https://typeshare.co'
        : 'https://typeshare-git-queue-typeshare.vercel.app';
    var url = domain + `/${slug}/essay-images/${userID}/${postID}`;

    const response = await fetch(
      `https://typeshare-imagen.vercel.app/api/screenshot${
        url ? `?url=${url}` : ''
      }`,
      {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        mode: 'cors',
      },
    );

    const data = await response.json();

    if (data.success) {
      setEssayImage(data.blob);
      setImageLoading(false);
      setImageNeedsRefresh(false);
      setImageError(false);
    } else {
      setImageError(true);
      setImageNeedsRefresh(false);
      setImageLoading(false);
    }
  };

  function saveAs() {
    var filename = `${
      headline ? headline.replace(/\s/g, '-') : 'Typeshare-Essay'
    }.jpg`;
    var link = document.createElement('a');

    if (typeof link.download === 'string') {
      link.href = essayImage;
      link.download = filename;

      //Firefox requires the link to be in the body
      document.body.appendChild(link);

      //simulate click
      link.click();

      //remove the link when done
      document.body.removeChild(link);
    } else {
      window.open(uri);
    }
  }

  const changeHeadline = (e) => {
    setHeadline(e.target.value);

    if (userID && postID) {
      firebase
        .database()
        .ref(`users/${userID}/typeshares`)
        .child(postID)
        .child('content')
        .update({
          titleText: e.target.value,
        })
        .then(() => {
          setImageNeedsRefresh(true);
        });
    } else {
      console.log('No userID or postID');
    }
  };

  const getSubtitle = (text) => {
    if (text) {
      var convertedText = text.replace(/<\/p>/g, ' ');

      convertedText = convertedText.replace(/<\/h2>/g, ' ');
      //replace </h3> with \n
      convertedText = convertedText.replace(/<\/h3>/g, ' ');

      //replace <li> with •
      convertedText = convertedText.replace(/(<li>)/g, '• ');

      //replace <br> with \n
      convertedText = convertedText.replace(/(<br>)/g, ' ');

      //replace <a target="_blank" rel="noopener noreferrer nofollow" href="https://google.com">...</a> with the href
      convertedText = convertedText.replace(
        /(<a target="_blank" rel="noopener noreferrer nofollow" href=")(.*)(">)(.*)(<\/a>)/g,
        '$2',
      );

      var pt = convertedText.replace(/<[^>]*>?/gm, '');
      pt = pt.trim();
      var ptText = convertToPlainText(pt);

      var tempSUB = ptText.substring(0, 90);
      //add ... if the text is longer than 90 characters
      if (ptText.length > 90) {
        tempSUB = tempSUB + '...';
      }

      setSubtitle(tempSUB);
    }
  };

  const convertToPlainText = (html) => {
    var el = document.createElement('div');
    el.innerHTML = html;
    var text = el.textContent;
    return text;
  };

  const changeSubtitle = (e) => {
    setSubtitle(e.target.value);

    if (userID && postID) {
      firebase
        .database()
        .ref(`users/${userID}/typeshares`)
        .child(postID)
        .child('preview')
        .update({
          subtitle: e.target.value,
        })
        .then(() => {});
    } else {
      console.log('No userID or postID');
    }
  };

  const safeSlug = (value) => {
    var slug = value.replace(/\s/g, '-').toLowerCase();
    //only allow letters, numbers, and dashes
    slug = slug.replace(/[^a-z0-9-]/g, '');
    //dont allow multiple dashes
    slug = slug.replace(/-{2,}/g, '-');

    return slug;
  };

  const changePostSlug = (e) => {
    const tmpSlug = safeSlug(e.target.value);
    setPostSlug(tmpSlug);

    if (userID && postID) {
      if (!tmpSlug) {
        firebase
          .database()
          .ref(`users/${userID}/typeshares`)
          .child(postID)
          .child('preview')
          .child('slug')
          .remove();
      } else {
        firebase
          .database()
          .ref(`users/${userID}/typeshares`)
          .child(postID)
          .child('preview')
          .update({
            slug: tmpSlug,
          })
          .then(() => {
            setHasCustomSlug(true);
          });
      }
    } else {
      console.log('No userID or postID');
    }
  };

  const changeTweetText = (val) => {
    setTweetText(val);
    setHasCustomTweetText(true);

    if (userID && postID) {
      firebase
        .database()
        .ref(`users/${userID}/typeshares`)
        .child(postID)
        .child('preview')
        .update({
          tweetText: val,
        })
        .then(() => {});
    } else {
      console.log('No userID or postID');
    }
  };

  const saveChanges = () => {};

  useEffect(() => {
    if (userID) {
      checkIfMediumConnected();
      checkIfLinkedinConnected();
    }
  }, [userID]);

  const checkIfMediumConnected = () => {
    var mediumIntegration = firebase
      .database()
      .ref('users/' + userID)
      .child('integrations/medium');

    mediumIntegration.once('value', function (snapshot) {
      if (snapshot.exists()) {
        setMediumProfile(snapshot.val().meta);
        // setMediumEnabled(true)
        setHasMedium(true);
        setMediumEnabled(true);
      } else {
        //setMediumEnabled(false)
        setHasMedium(false);
        setMediumEnabled(false);
      }
    });
  };

  const checkIfLinkedinConnected = () => {
    var integration = firebase
      .database()
      .ref('users/' + userID)
      .child('integrations/linkedin');

    integration
      .once('value', function (snapshot) {
        if (snapshot.exists()) {
          setLinkedinProfile(snapshot.val());
          if (snapshot.val().expiry < new Date().getTime()) {
            //expiry is in the past
            // setLinkedinEnabled(false);
            setLinkedinExpired(true);
            setHasLinkedin(true);
            setLinkedinEnabled(false);
          } else {
            //expiry is in the future
            //setLinkedinEnabled(true)
            setLinkedinExpired(false);
            setHasLinkedin(true);
            setLinkedinEnabled(true);
          }
        } else {
          //setLinkedinEnabled(false)
          setHasLinkedin(false);
          setLinkedinEnabled(false);
        }
      })
      .then(() => {});
  };

  const [collectionImageURL, setCollectionImageURL] = useState(null);

  useEffect(() => {
    if (selectedCollection && userID) {
      if (selectedCollection.image.image && selectedCollection.slug) {
        getImage(selectedCollection.slug, selectedCollection.image.image);
      }
    }
  }, [selectedCollection]);

  const getImage = (colSlug, imageKey) => {
    var storageRef2 = firebase.storage().ref();
    var imgRef = storageRef2
      .child(userID)
      .child('collections')
      .child(colSlug)
      .child(`${imageKey}`);

    imgRef.getDownloadURL().then((url) => {
      setCollectionImageURL(url);
    });
  };

  const changeShareTwitter = (val) => {
    setEnabled(val);

    /*  if (userID && postID) {
             firebase.database().ref(`users/${userID}/typeshares`).child(postID).child("settings").child("shareTo").update({
                 twitter: val
             })
         } else {
             console.log("No userID or postID")
         } */
  };

  const changeShareMedium = (val) => {
    setMediumEnabled(val);

    /*  if (userID && postID) {
             firebase.database().ref(`users/${userID}/typeshares`).child(postID).child("settings").child("shareTo").update({
                 medium: val
             })
         } else {
             console.log("No userID or postID")
         } */
  };

  const changeShareLinkedIn = (val) => {
    setLinkedinEnabled(val);

    /*   if (userID && postID) {
              firebase.database().ref(`users/${userID}/typeshares`).child(postID).child("settings").child("shareTo").update({
                  linkedin: val
              })
  
          } else {
              console.log("No userID or postID")
          } */
  };

  const [twitterScheduling, setTwitterScheduling] = useState(false);
  const [mediumScheduling, setMediumScheduling] = useState(false);
  const [linkedinScheduling, setLinkedinScheduling] = useState(false);
  const [needsEditorFix, setNeedsEditorFix] = useState(false);

  const schedulePost = async () => {
    //check if activeSlotUnix is in the past
    if (activeSlotUnix < new Date().getTime()) {
      console.log('activeSlotUnix is in the past');
      setNeedsEditorFix(false);
      setErrorMSG('Please select a slot in the future');
      setTypeshareError(true);
    } else {
      //VALIDATE EACH DESTINATION BEFORE PUBLISHING TO ANY OF THEM

      setScheduling(true);

      if (enabled) {
        setTwitterScheduling(true);
        if (twitterType === 'thread') {
          //show loaders before validating
          mediumEnabled && setMediumScheduling(true);
          linkedinEnabled && setLinkedinScheduling(true);

          const threadData = await getThread();
          if (threadData) {
            //POST TO TWITTER
            scheduleThread(threadData);
            mediumEnabled && scheduleMedium();
            linkedinEnabled && scheduleLinkedin();
            publishTypeshare();
            //check for other destinations
          } else {
            setTwitterScheduling(false);
            setScheduling(false);
            setTwitterError(true);
            setErrorMSG('There was an error with your thred');
            setNeedsEditorFix(true);
            setMediumScheduling(false);
            setLinkedinScheduling(false);
            //thread has an error
          }
        } else if (twitterType === 'image') {
          const imageData = await validateImage({ tweetText, essayImage });
          if (imageData.success) {
            //POST TO TWITTER
            scheduleImage(imageData);
            mediumEnabled && scheduleMedium();
            linkedinEnabled && scheduleLinkedin();
            publishTypeshare();
            //check for other destinations
          } else {
            setTwitterScheduling(false);
            setTwitterError(true);
            setErrorMSG(imageData.message);
            setNeedsEditorFix(false);
            setScheduling(false);
          }
        }
      } else {
        //not sharing to twitter
        mediumEnabled && scheduleMedium();
        linkedinEnabled && scheduleLinkedin();
        publishTypeshare();
      }
    }
  };

  useEffect(() => {
    if (postID) {
      setErrorMSG(null);
      setTypeshareError(false);
      setTwitterError(false);
      setSlugError(false);
    }
  }, [postID]);

  useEffect(() => {
    if (open) {
      setScheduling(false);
      setTwitterScheduling(false);
      setMediumScheduling(false);
      setLinkedinScheduling(false);
      setSocialBlogSuccess(false);
      setTwitterSize(null);
      setTwitterSuccess(false);
      setMediumSuccess(false);
      setLinkedinSuccess(false);
      setTypeshareError(false);
      setLinkedinTextReady(false);
    }
  }, [open]);

  useEffect(() => {
    if (twitterError && errorMSG === "You can't mention the same user twice") {
      setTwitterError(false);
    }
  }, [tweetText]);

  useEffect(() => {
    //only close if all the selected destinations are done and successful
    //if they arent, then show errors for the ones that failed and keep the modal open
    //this should be very very rare - because we validate before scheduling and we are just doing database shit - not actually posting to the platforms right now

    if (socialBlogSuccess) {
      if (!enabled && !mediumEnabled && !linkedinEnabled) {
        //only publish to typeshare
        //close slideover and refresh queue
        refreshQueue();
        scheduledToast({
          headline: headline,
          postID: postSlug ? postSlug : postID,
        });
        setOpen(false);
      } else if (enabled && twitterSuccess) {
        //twitter
        refreshQueue();
        scheduledToast({
          headline: headline,
          postID: postSlug ? postSlug : postID,
        });
        setOpen(false);
      } else if (mediumEnabled && mediumSuccess) {
        //medium
        refreshQueue();
        scheduledToast({
          headline: headline,
          postID: postSlug ? postSlug : postID,
        });
        setOpen(false);
      } else if (linkedinEnabled && linkedinSuccess) {
        //linkedin
        refreshQueue();
        scheduledToast({
          headline: headline,
          postID: postSlug ? postSlug : postID,
        });
        setOpen(false);
      } else if (enabled && twitterSuccess && mediumEnabled && mediumSuccess) {
        //twitter and medium
        // console.log('Twitter and Medium are enabled and successfully published')
        refreshQueue();
        scheduledToast({
          headline: headline,
          postID: postSlug ? postSlug : postID,
        });
        setOpen(false);
      } else if (
        enabled &&
        twitterSuccess &&
        linkedinEnabled &&
        linkedinSuccess
      ) {
        //twitter and linkedin
        // console.log('Twitter and Linkedin are enabled and successfully published')
        refreshQueue();
        scheduledToast({
          headline: headline,
          postID: postSlug ? postSlug : postID,
        });
        setOpen(false);
      } else if (
        mediumEnabled &&
        mediumSuccess &&
        linkedinEnabled &&
        linkedinSuccess
      ) {
        //medium and linkedin
        // console.log('Medium and Linkedin are enabled and successfully published')
        refreshQueue();
        scheduledToast({
          headline: headline,
          postID: postSlug ? postSlug : postID,
        });
        setOpen(false);
      } else if (
        enabled &&
        twitterSuccess &&
        mediumEnabled &&
        mediumSuccess &&
        linkedinEnabled &&
        linkedinSuccess
      ) {
        //twitter, medium and linkedin
        // console.log('Twitter, Medium and Linkedin are enabled and successfully published')
        refreshQueue();
        scheduledToast({
          headline: headline,
          postID: postSlug ? postSlug : postID,
        });
        setOpen(false);
      }
    }
  }, [socialBlogSuccess, twitterSuccess, mediumSuccess, linkedinSuccess]);

  const publishTypeshare = async () => {
    const ts = await publishToTypeshare({
      isScheduled: true,
      username: slug,
      shareToTwitter: enabled,
      shareToLinkedIn: linkedinEnabled,
      shareToMedium: mediumEnabled,
      isThread: twitterType === 'thread' ? true : false,
      threadMeta,
      pubTime: activeSlotUnix,
      collectionID: selectedCollection ? selectedCollection.slug : null,
      postID,
      subtitle,
      altText,
      customSlug: postSlug,
    });

    if (ts) {
      //console.log('Typeshare successfully published')
      setScheduling(false);
      setSocialBlogSuccess(true);
    } else {
      setTypeshareError(true);
      setSocialBlogSuccess(false);
      setErrorMSG('Something went wrong');
    }
  };

  const scheduleThread = async (tweetArray) => {
    const scheduledThread = await tweetScheduledThread({
      tweetArray,
      unix: activeSlotUnix,
      userID,
      slug: postID,
    });

    if (scheduledThread) {
      if (scheduledThread.success) {
        setTwitterSuccess(true);
        // console.log('Twitter successfully scheduled')
        return true;
      } else {
        setTwitterSuccess(false);
        return false;
      }
    } else {
      return false;
    }
  };

  const scheduleImage = async () => {
    //console.log('Scheduling image')

    //var b64 = essayImage.replace("data:image/png;base64,", "")
    var b64 = essayImage.replace('data:image/jpeg;base64,', '');

    const image = await scheduleEssayImage({
      unix: activeSlotUnix,
      galleryUsername: slug,
      userID,
      activeTypeshareID: postID,
      tweetText,
      altText,
      attachLink,
      b64,
      currentSlug: postSlug,
      passedCollectionID: selectedCollection ? selectedCollection.id : null,
    });

    // console.log(image, "image")

    if (image) {
      if (image.success) {
        setTwitterSuccess(true);
        //     console.log('Twitter successfully scheduled')
        return true;
      } else {
        setTwitterSuccess(false);
        return false;
      }
    }
  };

  const scheduleMedium = async () => {
    setMediumScheduling(true);

    const medium = await scheduleMediumPost({
      unix: activeSlotUnix,
      galleryUsername: slug,
      userID,
      activeTypeshareID: postID,
      attachLink,
      currentSlug: postSlug,
    });

    if (medium) {
      if (medium.success) {
        setMediumScheduling(false);
        setMediumSuccess(true);
        //   console.log('Medium successfully scheduled')
        return true;
      } else {
        setMediumScheduling(false);
        setMediumSuccess(false);
        return false;
      }
    }
  };

  const scheduleLinkedin = async () => {
    setLinkedinScheduling(true);

    const linkedin = await scheduleLinkedinPost({
      unix: activeSlotUnix,
      galleryUsername: slug,
      userID,
      activeTypeshareID: postID,
      attachLink,
      currentSlug: postSlug,
    });

    if (linkedin) {
      if (linkedin.success) {
        setLinkedinSuccess(true);
        setLinkedinScheduling(false);
        //  console.log('Linkedin successfully scheduled')
        return true;
      } else {
        setLinkedinSuccess(false);
        setLinkedinScheduling(false);
        return false;
      }
    }
  };

  const getThread = async () => {
    const thread = await formatThread({
      rawTweetArray,
      imageDataArray,
      imageIDArray,
      twitterThreadText,
      twitterHandle,
      galleryUsername: slug,
      userID,
      tSlug: postID,
    });

    if (thread) {
      if (thread.success) {
        setTwitterError(false);
        const data = thread.data;
        return data;
        //all ready to share to Twitter
        //SHARE TO TWITTER HERE
      } else {
        setErrorMSG(thread.message);
        setTwitterError(true);
        return false;
      }
    }
  };

  const [imageSize, setImageSize] = useState(3);

  const imageSizes = {
    0: 'Tiny',
    1: 'Small',
    2: 'Medium',
    3: 'Large',
  };

  useEffect(() => {
    if (userID && postID) {
      getImageSize();
    }
  }, [userID, postID]);

  const getImageSize = () => {
    firebase
      .database()
      .ref(`users`)
      .child(userID)
      .child('typeshares')
      .child(postID)
      .child('settings')
      .child('imageSize')
      .once('value', (snapshot) => {
        if (snapshot.exists()) {
          const imgSize = snapshot.val();
          const index = Object.keys(imageSizes).find(
            (key) => imageSizes[key] === imgSize,
          );
          setImageSize(index);
        }
      });
  };

  const decreaseImageSize = (size) => {
    var intSize = parseInt(size);
    const newSizeIndex = intSize <= 0 ? 0 : intSize - 1;

    firebase
      .database()
      .ref(`users`)
      .child(userID)
      .child('typeshares')
      .child(postID)
      .child('settings')
      .update({
        imageSize: imageSizes[newSizeIndex],
      })
      .then(() => {
        setImageSize(newSizeIndex);
        revalidateAndFetch();
      });
  };

  const increaseImageSize = (size) => {
    //convert size to integer

    var intSize = parseInt(size);

    const newSizeIndex = intSize >= 3 ? 3 : intSize + 1;

    firebase
      .database()
      .ref(`users`)
      .child(userID)
      .child('typeshares')
      .child(postID)
      .child('settings')
      .update({
        imageSize: imageSizes[newSizeIndex],
      })
      .then(() => {
        setImageSize(newSizeIndex);
        revalidateAndFetch();
      });
  };

  const revalidateAndFetch = async () => {
    if (slug && postID && userID) {
      setImageLoading(true);
      try {
        await client.get(
          `/api/revalidate?secret=SGDF67SDOHI&path=/${slug}/essay-images/${userID}/${postID}`,
        );
        return generateIMG();
      } catch (err) {
        console.error(err);
      }
    } else {
      console.log('Missing params');
    }
  };

  const saveCustomLinkedinText = (val) => {
    firebase
      .database()
      .ref(`users`)
      .child(userID)
      .child('typeshares')
      .child(postID)
      .child('content')
      .update({
        linkedinText: val,
      });
  };

  const removeCustomLinkedinText = () => {
    firebase
      .database()
      .ref(`users`)
      .child(userID)
      .child('typeshares')
      .child(postID)
      .child('content')
      .child('linkedinText')
      .remove();
  };

  const [slugError, setSlugError] = useState(false);

  useEffect(() => {
    if (userID && postSlug) {
      checkIfSlugIsUnique(postSlug);
    }
  }, [postSlug]);

  async function checkIfSlugIsUnique(slugPassed) {
    if (slugPassed.length > 0) {
      const snapshot = await firebase
        .database()
        .ref('paths/posts/' + userID + '/posts/')
        .once('value');
      var hasSlug = snapshot.hasChild(slugPassed);

      if (hasSlug) {
        if (snapshot.val()[slugPassed] === postID) {
          setSlugError(false);
          return true;
        } else {
          setSlugError(true);
          return false;
        }
      } else {
        setSlugError(false);
        snapshot.forEach((child) => {
          if (child.key.toLocaleLowerCase() === slugPassed) {
            //missed case evaluation in prior check
            setSlugError(true);
            return false;
          }
        });
        return true;
      }
    }
  }

  async function generateSlug(initialTitle) {
    if (initialTitle) {
      var cSlug = initialTitle
        .replace(/\s+/g, '-')
        .replace(/[^a-z\d\-]/gi, '')
        .toLowerCase();
      const isUnique = await checkIfSlugIsUnique(cSlug);

      if (isUnique) {
        setPostSlug(cSlug);
      } else {
        //generate a string of four url safe characters to append to the slug
        var randomString = Math.random().toString(36).substring(2, 6);
        var newSlug = cSlug + '-' + randomString;
        setPostSlug(newSlug);
      }
    }
  }

  const [linkedinTextReady, setLinkedinTextReady] = useState(false);

  const updateLinkedinText = async (val) => {
    setLinkedinText(val);

    if (userID && postID) {
      await firebase
        .database()
        .ref(`users`)
        .child(userID)
        .child('typeshares')
        .child(postID)
        .child('content')
        .update({
          linkedinPlainText: val,
        });

      setLinkedinTextReady(true);
    }
  };

  return (
    <>
      <AddToCollection
        selected={selectedCollection}
        setSelected={setSelectedCollection}
        productName={productName}
        open={addToCollectionModal}
        setOpen={setAddToCollectionModal}
        galleryUsername={slug}
        userID={userID}
      />
      <Transition.Root show={open} as={Fragment}>
        <Dialog as="div" className="relative z-30" onClose={setOpen}>
          <Transition.Child
            as={Fragment}
            enter="ease-in-out duration-500"
            enterFrom="opacity-0"
            enterTo="opacity-100"
            leave="ease-in-out duration-500"
            leaveFrom="opacity-100"
            leaveTo="opacity-0"
          >
            <div className="fixed inset-0 bg-gray-500 bg-opacity-50 transition-opacity" />
          </Transition.Child>

          <div className="fixed inset-0 overflow-hidden antialiased">
            <div className="absolute inset-0 overflow-hidden">
              <div className="pointer-events-none fixed inset-y-0 right-0 flex max-w-full md:pl-10">
                <Transition.Child
                  as={Fragment}
                  enter="transform transition ease-in-out duration-500 sm:duration-700"
                  enterFrom="translate-x-full"
                  enterTo="translate-x-0"
                  leave="transform transition ease-in-out duration-500 sm:duration-700"
                  leaveFrom="translate-x-0"
                  leaveTo="translate-x-full"
                >
                  <Dialog.Panel className="pointer-events-auto w-screen max-w-lg">
                    <div
                      style={{
                        boxShadow:
                          'rgba(15, 15, 15, 0.016) 0px 0px 0px 1px, rgba(15, 15, 15, 0.03) 0px 3px 6px, rgba(15, 15, 15, 0.06) 0px 9px 24px',
                      }}
                      className="relative flex h-full flex-col overflow-y-scroll bg-gray-50"
                    >
                      <div className="sticky top-0 z-10 flex w-full flex-col bg-gray-50 pt-2">
                        <div className="bg-gray-50 px-1 sm:px-2">
                          <div className="flex items-center justify-between">
                            <div className="flex flex-row items-center justify-end space-x-0">
                              <Tooltip
                                html={
                                  <div className="flex flex-col items-start justify-start text-sm font-semibold antialiased">
                                    <p className="text-xs text-white">Close</p>
                                  </div>
                                }
                                position="bottom"
                                interactive={false}
                                animateFill={false}
                                theme="dark"
                                arrow={true}
                                arrowSize="small"
                                trigger="mouseenter"
                                offset={1}
                                disabled={false}
                              >
                                <button
                                  onClick={() => setOpen(false)}
                                  className="rounded-md p-1 text-gray-500  hover:bg-gray-200 hover:text-gray-700 focus:border-0 focus:outline-none"
                                >
                                  <svg
                                    xmlns="http://www.w3.org/2000/svg"
                                    viewBox="0 0 20 20"
                                    fill="currentColor"
                                    className="h-5 w-5"
                                  >
                                    <path
                                      fillRule="evenodd"
                                      d="M10.21 14.77a.75.75 0 01.02-1.06L14.168 10 10.23 6.29a.75.75 0 111.04-1.08l4.5 4.25a.75.75 0 010 1.08l-4.5 4.25a.75.75 0 01-1.06-.02z"
                                      clipRule="evenodd"
                                    />
                                    <path
                                      fillRule="evenodd"
                                      d="M4.21 14.77a.75.75 0 01.02-1.06L8.168 10 4.23 6.29a.75.75 0 111.04-1.08l4.5 4.25a.75.75 0 010 1.08l-4.5 4.25a.75.75 0 01-1.06-.02z"
                                      clipRule="evenodd"
                                    />
                                  </svg>
                                </button>
                              </Tooltip>
                            </div>

                            <Tooltip
                              html={
                                <div className="flex flex-col items-start justify-start text-sm font-semibold antialiased">
                                  <p className="text-xs text-white">
                                    Open in Editor
                                  </p>
                                </div>
                              }
                              position="bottom"
                              interactive={false}
                              arrow={true}
                              arrowSize="small"
                              animateFill={false}
                              theme="dark"
                              trigger="mouseenter"
                              offset={1}
                              disabled={false}
                            >
                              <Link
                                href={`/editor/${encodeURIComponent(postID)}`}
                                className="flex cursor-pointer items-center justify-center rounded-md p-1.5 text-gray-500 hover:bg-gray-200 hover:text-gray-700"
                              >
                                <svg
                                  xmlns="http://www.w3.org/2000/svg"
                                  viewBox="0 0 20 20"
                                  fill="currentColor"
                                  className="h-4 w-4"
                                >
                                  <path d="M13.28 7.78l3.22-3.22v2.69a.75.75 0 001.5 0v-4.5a.75.75 0 00-.75-.75h-4.5a.75.75 0 000 1.5h2.69l-3.22 3.22a.75.75 0 001.06 1.06zM2 17.25v-4.5a.75.75 0 011.5 0v2.69l3.22-3.22a.75.75 0 011.06 1.06L4.56 16.5h2.69a.75.75 0 010 1.5h-4.5a.747.747 0 01-.75-.75zM12.22 13.28l3.22 3.22h-2.69a.75.75 0 000 1.5h4.5a.747.747 0 00.75-.75v-4.5a.75.75 0 00-1.5 0v2.69l-3.22-3.22a.75.75 0 10-1.06 1.06zM3.5 4.56l3.22 3.22a.75.75 0 001.06-1.06L4.56 3.5h2.69a.75.75 0 000-1.5h-4.5a.75.75 0 00-.75.75v4.5a.75.75 0 001.5 0V4.56z" />
                                </svg>
                              </Link>
                            </Tooltip>

                            {/*  <div className='flex flex-row space-x-1 items-center justify-end'>


                                                        <Menu as="div" className="relative inline-block text-left">
                                                            <Tooltip
                                                                html={
                                                                    <div className="font-semibold antialiased text-sm flex flex-col items-start justify-start">
                                                                        <p className="text-xs text-white">
                                                                            Post settings, and more
                                                                        </p>
                                                                    </div>
                                                                }
                                                                position="bottom"
                                                                interactive={false}

                                                                animateFill={false}
                                                                theme="dark"
                                                                arrow={true}
                                                                arrowSize="small"
                                                                trigger="mouseenter"
                                                                offset={1}
                                                                disabled={false}
                                                            >


                                                                <Menu.Button className='p-0.5 rounded-md hover:bg-gray-200 text-gray-500 hover:text-gray-700 cursor-pointer '>
                                                                    <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" strokeWidth={1.5} stroke="currentColor" className="w-5 h-5">
                                                                        <path strokeLinecap="round" strokeLinejoin="round" d="M6.75 12a.75.75 0 11-1.5 0 .75.75 0 011.5 0zM12.75 12a.75.75 0 11-1.5 0 .75.75 0 011.5 0zM18.75 12a.75.75 0 11-1.5 0 .75.75 0 011.5 0z" />
                                                                    </svg>

                                                                </Menu.Button>

                                                            </Tooltip>

                                                            <Transition
                                                                as={Fragment}
                                                                enter="transition ease-out duration-100"
                                                                enterFrom="transform opacity-0 scale-95"
                                                                enterTo="transform opacity-100 scale-100"
                                                                leave="transition ease-in duration-75"
                                                                leaveFrom="transform opacity-100 scale-100"
                                                                leaveTo="transform opacity-0 scale-95"
                                                            >
                                                                <Menu.Items className="absolute right-0 z-10 mt-2 w-56 origin-top-right divide-y divide-gray-100 rounded-md bg-white shadow-lg ring-1 ring-black ring-opacity-5 focus:outline-none">
                                                                    <div className=" p-1">
                                                                        <div className='p-1.5'>
                                                                            <p className='text-xs font-medium text-gray-500 uppercase'>Post Settings</p>
                                                                        </div>
                                                                        <Menu.Item>
                                                                            {({ active }) => (
                                                                                <a
                                                                                    href="#"
                                                                                    className={classNames(
                                                                                        active ? 'bg-gray-100 text-gray-900' : 'text-gray-900',
                                                                                        'group flex items-center px-2 py-1 text-sm rounded-md font-medium'
                                                                                    )}
                                                                                >
                                                                                    <PencilIcon
                                                                                        className="mr-2 h-4 w-4 text-gray-900"
                                                                                        aria-hidden="true"
                                                                                    />
                                                                                    Edit Post Preview
                                                                                </a>
                                                                            )}
                                                                        </Menu.Item>
                                                                        <Menu.Item>
                                                                            {({ active }) => (
                                                                                <a
                                                                                    href="#"
                                                                                    className={classNames(
                                                                                        active ? 'bg-gray-100 text-gray-900' : 'text-gray-900',
                                                                                        'group flex items-center px-2 py-1 text-sm rounded-md font-medium'
                                                                                    )}
                                                                                >
                                                                                    <FolderAddIcon
                                                                                        className="mr-2 h-4 w-4 text-gray-900"
                                                                                        aria-hidden="true"
                                                                                    />
                                                                                    Add to Colllection
                                                                                </a>
                                                                            )}
                                                                        </Menu.Item>
                                                                    </div>

                                                                    <div className="py-2 px-3 flex flex-col space-y-0.5">
                                                                        <p className='text-gray-500 text-xs'>Word count: 65</p>
                                                                        <p className='text-gray-500 text-xs'>Created: May 1, 2022</p>
                                                                    </div>
                                                                </Menu.Items>
                                                            </Transition>
                                                        </Menu>




                                                    </div> */}
                          </div>
                        </div>
                        {(enabled && imageError) || hasError ? (
                          <div className="mt-1 flex min-h-[46px] w-full flex-row items-center justify-between space-x-1 overflow-hidden bg-red-500 p-2 text-sm font-medium text-white">
                            <div className="flex flex-row items-center justify-start space-x-1">
                              <svg
                                xmlns="http://www.w3.org/2000/svg"
                                viewBox="0 0 20 20"
                                fill="currentColor"
                                className="h-4 w-4"
                              >
                                <path
                                  fillRule="evenodd"
                                  d="M18 10a8 8 0 11-16 0 8 8 0 0116 0zm-8-5a.75.75 0 01.75.75v4.5a.75.75 0 01-1.5 0v-4.5A.75.75 0 0110 5zm0 10a1 1 0 100-2 1 1 0 000 2z"
                                  clipRule="evenodd"
                                />
                              </svg>

                              <p>
                                This post needs to be scheduled in the editor.
                              </p>
                            </div>

                            <button className="rounded-full border border-white px-3 py-1 text-sm font-medium text-white duration-150 hover:bg-gray-900/10">
                              Open in Editor
                            </button>
                          </div>
                        ) : null}
                      </div>
                      <div className="relative mt-2 flex-1 px-6 pb-8 sm:px-8">
                        <div className="flex w-full flex-col items-start justify-start space-y-8">
                          <div className="flex w-full flex-col space-y-6">
                            <div className="group flex flex-col items-start justify-start">
                              <div className="flex flex-row items-center justify-start space-x-2">
                                <button
                                  onClick={() => setAddToCollectionModal(true)}
                                  className={`-translate-x-1.5 px-2 py-1 pl-1 ${
                                    selectedCollection
                                      ? 'opacity-100'
                                      : 'opacity-0'
                                  } flex flex-row items-center justify-center space-x-1 rounded-md text-sm font-medium text-gray-500 duration-150 hover:bg-gray-200/75 hover:text-gray-700 group-hover:opacity-100`}
                                >
                                  {selectedCollection ? (
                                    <img
                                      src={collectionImageURL}
                                      className="h-5 w-5 rounded-full"
                                    />
                                  ) : (
                                    <svg
                                      xmlns="http://www.w3.org/2000/svg"
                                      viewBox="0 0 20 20"
                                      fill="currentColor"
                                      className="h-5 w-5"
                                    >
                                      <path
                                        fillRule="evenodd"
                                        d="M3.75 3A1.75 1.75 0 002 4.75v10.5c0 .966.784 1.75 1.75 1.75h12.5A1.75 1.75 0 0018 15.25v-8.5A1.75 1.75 0 0016.25 5h-4.836a.25.25 0 01-.177-.073L9.823 3.513A1.75 1.75 0 008.586 3H3.75zM10 8a.75.75 0 01.75.75v1.5h1.5a.75.75 0 010 1.5h-1.5v1.5a.75.75 0 01-1.5 0v-1.5h-1.5a.75.75 0 010-1.5h1.5v-1.5A.75.75 0 0110 8z"
                                        clipRule="evenodd"
                                      />
                                    </svg>
                                  )}
                                  <p className="whitespace-nowrap">
                                    {selectedCollection
                                      ? selectedCollection?.title
                                      : 'Add to Collection'}
                                  </p>
                                </button>

                                {/*  <button className='px-2 -translate-x-1.5 py-1 pl-1 opacity-0 group-hover:opacity-100 duration-150 flex flex-row space-x-1 rounded-md text-gray-500 font-medium text-sm items-center justify-center hover:bg-gray-200/75 hover:text-gray-700'>
                                                                <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20" fill="currentColor" className="w-5 h-5">
                                                                    <path fillRule="evenodd" d="M19 10.5a8.5 8.5 0 11-17 0 8.5 8.5 0 0117 0zM8.25 9.75A.75.75 0 019 9h.253a1.75 1.75 0 011.709 2.13l-.46 2.066a.25.25 0 00.245.304H11a.75.75 0 010 1.5h-.253a1.75 1.75 0 01-1.709-2.13l.46-2.066a.25.25 0 00-.245-.304H9a.75.75 0 01-.75-.75zM10 7a1 1 0 100-2 1 1 0 000 2z" clipRule="evenodd" />
                                                                </svg>

                                                                <p className='whitespace-nowrap'>Edit Preview</p>
                                                            </button> */}
                              </div>

                              <TextareaAutosize
                                placeholder="Add a headline..."
                                value={headline}
                                onChange={(e) => changeHeadline(e)}
                                className={`w-full resize-none whitespace-pre-wrap border-none border-transparent bg-transparent p-0 text-3xl font-bold leading-tight tracking-tightish  text-gray-900 placeholder-gray-500 focus:outline-none focus:ring-transparent disabled:text-gray-600`}
                              ></TextareaAutosize>
                            </div>
                            <div className="flex flex-col space-y-3">
                              <div className="flex flex-col space-y-0.5">
                                <div className="grid w-full grid-cols-6 items-start text-sm font-medium text-gray-500 ">
                                  <div className="col-span-2 mt-[1px] flex flex-row items-center space-x-1.5 whitespace-nowrap py-1.5">
                                    <svg
                                      xmlns="http://www.w3.org/2000/svg"
                                      fill="none"
                                      viewBox="0 0 24 24"
                                      strokeWidth={1.8}
                                      stroke="currentColor"
                                      className="h-4 w-4"
                                    >
                                      <path
                                        strokeLinecap="round"
                                        strokeLinejoin="round"
                                        d="M3.75 6.75h16.5M3.75 12h16.5m-16.5 5.25h16.5"
                                      />
                                    </svg>

                                    <p>Post Subtitle</p>
                                  </div>

                                  <div className="col-span-4 flex flex-row items-center justify-start rounded-md border border-transparent duration-100 hover:border-gray-200 hover:bg-gray-200/50">
                                    <TextareaAutosize
                                      placeholder="Add a subtitle..."
                                      value={subtitle}
                                      onChange={(e) => changeSubtitle(e)}
                                      className={`w-full resize-none whitespace-pre-wrap border-none border-transparent bg-transparent p-0 px-2 py-2 text-sm font-medium leading-tight tracking-tightish  text-gray-900 placeholder-gray-500 focus:outline-none focus:ring-transparent disabled:text-gray-600`}
                                    ></TextareaAutosize>
                                  </div>
                                </div>

                                <div className="grid w-full grid-cols-6 items-start text-sm font-medium text-gray-500">
                                  <div className="col-span-2 mt-[1px] flex flex-row items-center space-x-1.5 whitespace-nowrap py-1.5">
                                    <svg
                                      xmlns="http://www.w3.org/2000/svg"
                                      fill="none"
                                      viewBox="0 0 24 24"
                                      strokeWidth={1.8}
                                      stroke="currentColor"
                                      className="h-4 w-4"
                                    >
                                      <path
                                        strokeLinecap="round"
                                        strokeLinejoin="round"
                                        d="M13.19 8.688a4.5 4.5 0 011.242 7.244l-4.5 4.5a4.5 4.5 0 01-6.364-6.364l1.757-1.757m13.35-.622l1.757-1.757a4.5 4.5 0 00-6.364-6.364l-4.5 4.5a4.5 4.5 0 001.242 7.244"
                                      />
                                    </svg>
                                    <p>Post Slug</p>
                                  </div>

                                  <div className="col-span-4 flex flex-row items-center justify-start rounded-md border border-transparent duration-100 hover:border-gray-200 hover:bg-gray-200/50">
                                    <p className="mr-1.5 ml-2 text-xs uppercase text-gray-900">
                                      /
                                    </p>
                                    <TextareaAutosize
                                      disabled={twitterType === 'thread'}
                                      maxLength={50}
                                      placeholder="your-post"
                                      value={postSlug}
                                      onChange={(e) => changePostSlug(e)}
                                      className={`w-full resize-none whitespace-pre-wrap border-none border-transparent bg-transparent p-0 py-2 pr-2 text-sm font-medium leading-tight tracking-tightish  text-gray-900 placeholder-gray-500 focus:outline-none focus:ring-transparent disabled:text-gray-600`}
                                    ></TextareaAutosize>
                                  </div>
                                </div>
                              </div>

                              <div className="h-[1px] w-full rounded-full bg-gray-100" />

                              <div className="flex flex-col space-y-2">
                                <div className="grid w-full grid-cols-6 gap-1 text-sm font-medium text-gray-500 md:gap-0">
                                  <div className="col-span-2 flex flex-row items-center space-x-1.5 whitespace-nowrap">
                                    <svg
                                      xmlns="http://www.w3.org/2000/svg"
                                      fill="none"
                                      viewBox="0 0 24 24"
                                      strokeWidth={1.8}
                                      stroke="currentColor"
                                      className="h-4 w-4"
                                    >
                                      <path
                                        strokeLinecap="round"
                                        strokeLinejoin="round"
                                        d="M6 12L3.269 3.126A59.768 59.768 0 0121.485 12 59.77 59.77 0 013.27 20.876L5.999 12zm0 0h7.5"
                                      />
                                    </svg>

                                    <p>Publishing To</p>
                                  </div>

                                  <div
                                    layout
                                    className="col-span-4 flex w-full flex-row space-x-2 overflow-auto py-1 no-scrollbar"
                                  >
                                    <div
                                      layout={'position'}
                                      className="rounded-[4px] bg-blue-400/20 px-1 py-0.5 text-xs font-medium text-blue-600"
                                    >
                                      <p>Typeshare</p>
                                    </div>
                                    {enabled && (
                                      <div
                                        layout={'position'}
                                        className="rounded-[4px] bg-blue-300/20 px-1 py-0.5 text-xs font-medium text-blue-500"
                                      >
                                        <p>Twitter</p>
                                      </div>
                                    )}
                                    {mediumEnabled && (
                                      <div
                                        layout={'position'}
                                        className="rounded-[4px] bg-gray-400/20 px-1 py-0.5 text-xs font-medium text-gray-600"
                                      >
                                        <p>Medium</p>
                                      </div>
                                    )}
                                    {linkedinEnabled && (
                                      <div
                                        layout={'position'}
                                        className="rounded-[4px] bg-indigo-400/20 px-1 py-0.5 text-xs font-medium text-indigo-600"
                                      >
                                        <p>LinkedIn</p>
                                      </div>
                                    )}
                                  </div>
                                </div>

                                <div className="grid w-full grid-cols-6 gap-1 text-sm font-medium text-gray-500 md:gap-0">
                                  <div className="col-span-2 flex flex-row items-center space-x-1.5 whitespace-nowrap">
                                    <svg
                                      xmlns="http://www.w3.org/2000/svg"
                                      fill="none"
                                      viewBox="0 0 24 24"
                                      strokeWidth={1.8}
                                      stroke="currentColor"
                                      className="h-4 w-4"
                                    >
                                      <path
                                        strokeLinecap="round"
                                        strokeLinejoin="round"
                                        d="M12 6v6h4.5m4.5 0a9 9 0 11-18 0 9 9 0 0118 0z"
                                      />
                                    </svg>

                                    <p>Scheduled For</p>
                                  </div>
                                  <div className="col-span-4 flex w-full flex-row flex-wrap gap-2 overflow-auto py-1 no-scrollbar">
                                    <div className="rounded-[4px] bg-orange-400/20 px-1 py-0.5 text-xs font-medium text-orange-600">
                                      <p>{activeSlotPretty}</p>
                                    </div>
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>

                          <div className="h-[1px] w-full rounded-full bg-gray-100" />

                          <div className="flex w-full flex-col items-start justify-start space-y-2">
                            <div className="flex w-full flex-row items-center justify-between">
                              <div className="flex flex-row items-center justify-center space-x-1 text-gray-600">
                                <TwitterBirdIcon className="h-5 w-5 fill-current" />

                                <p className="text-sm font-medium text-gray-600">
                                  Twitter (
                                  {twitterType.charAt(0).toUpperCase() +
                                    twitterType.slice(1)}
                                  )
                                </p>
                              </div>

                              {twitterUser ? (
                                twitterSuccess ? (
                                  <CheckCircleIcon className="h-5 w-5 text-orange-500" />
                                ) : twitterScheduling ? (
                                  <SpinnerIcon className="h-5 w-5 animate-spin text-gray-500" />
                                ) : (
                                  <Switch
                                    checked={enabled}
                                    onChange={() =>
                                      changeShareTwitter(!enabled)
                                    }
                                    className={classNames(
                                      enabled ? 'bg-blue-500' : 'bg-gray-200',
                                      'relative inline-flex h-6 w-11 flex-shrink-0 cursor-pointer rounded-full border-2 border-transparent transition-colors duration-200 ease-in-out focus:outline-none focus:ring-2 focus:ring-indigo-500 focus:ring-offset-2',
                                    )}
                                  >
                                    <span className="sr-only">Use setting</span>
                                    <span
                                      aria-hidden="true"
                                      className={classNames(
                                        enabled
                                          ? 'translate-x-5'
                                          : 'translate-x-0',
                                        'pointer-events-none inline-block h-5 w-5 transform rounded-full bg-white shadow ring-0 transition duration-200 ease-in-out',
                                      )}
                                    />
                                  </Switch>
                                )
                              ) : (
                                <Button
                                  click={() =>
                                    router.push('/settings/integrations')
                                  }
                                  variant={'outline'}
                                  size={'mini'}
                                >
                                  Connect Twitter
                                </Button>
                              )}
                            </div>
                            {enabled ? (
                              twitterType === 'thread' ? (
                                <div className="max-h-96 w-full cursor-pointer items-end justify-end space-y-2 overflow-auto rounded-xl border border-gray-100 bg-white p-2">
                                  <ThreadPreview
                                    twitterSecret={twitterSecret}
                                    twitterToken={twitterToken}
                                    passThreadMeta={setThreadMeta}
                                    activeTypeshareID={postID}
                                    userID={userID}
                                    twitterEditorText={twitterEditorText}
                                    twitterHandle={twitterHandle}
                                    twitterName={twitterName}
                                    twitterPhoto={twitterPhoto}
                                    passRawTweetArray={setRawTweetArray}
                                    passImageIDArray={setImageIDArray}
                                    passImageDataArray={setImageDataArray}
                                    passTwitterText={setTwitterThreadText}
                                  />
                                </div>
                              ) : (
                                <div className="w-full cursor-pointer items-end justify-end space-y-2 rounded-xl border border-gray-100 bg-white p-2">
                                  <div className="w-full space-y-2 px-2 py-2">
                                    <div className="flex flex-row items-center space-x-2">
                                      <img
                                        className="h-8 w-8 rounded-full"
                                        src={twitterPhoto}
                                      />
                                      <div className="flex flex-col">
                                        <p className="text-sm font-semibold tracking-tightish text-gray-900">
                                          {twitterName}
                                        </p>
                                        <p className="text-xs text-gray-500">
                                          @{twitterHandle}
                                        </p>
                                      </div>
                                    </div>

                                    <TextareaAutosize
                                      placeholder="Click to add some tweet text..."
                                      value={tweetText}
                                      onChange={(e) =>
                                        changeTweetText(e.target.value)
                                      }
                                      className={`w-full resize-none whitespace-pre-wrap border-none border-transparent bg-transparent p-0 font-thread text-base leading-tight  text-gray-900 placeholder-gray-500 focus:outline-none focus:ring-transparent disabled:text-gray-600`}
                                    ></TextareaAutosize>

                                    {essayImage &&
                                    !imageLoading &&
                                    !imageNeedsRefresh &&
                                    !imageError ? (
                                      <div className="relative max-h-[593px] w-full overflow-auto rounded-lg border border-gray-100">
                                        <img
                                          src={essayImage}
                                          id={'essay-preview'}
                                          className={'object-cover'}
                                          ref={imageContainer}
                                        />
                                      </div>
                                    ) : (
                                      <div
                                        className={`relative flex h-[200px] w-full flex-row items-center justify-center overflow-auto rounded-lg border border-gray-200 bg-gray-100`}
                                      >
                                        {imageNeedsRefresh && !imageLoading ? (
                                          <div className="flex flex-col space-y-2">
                                            <p className="text-sm font-medium text-gray-700">
                                              Your Image Needs to be Regenerated
                                            </p>
                                            <Button
                                              click={() => revalidateAndFetch()}
                                              size={'mini'}
                                              width={'full'}
                                              variant={'outline-secondary'}
                                            >
                                              Regenerate Image
                                            </Button>
                                          </div>
                                        ) : imageError && !imageLoading ? (
                                          <div className="flex flex-col space-y-2">
                                            <p className="text-sm font-medium text-red-600">
                                              Couldn't generate image. Please
                                              open the editor.
                                            </p>
                                            <Button
                                              click={() => null}
                                              size={'mini'}
                                              width={'full'}
                                              variant={'outline-secondary'}
                                            >
                                              Open in Editor
                                            </Button>
                                          </div>
                                        ) : (
                                          <div className="relative flex items-center justify-center">
                                            <SpinnerIcon
                                              className={
                                                'h-10 w-10 animate-spin text-gray-500'
                                              }
                                            />

                                            <div className="absolute top-1/2 left-1/2 -translate-y-1/2 -translate-x-1/2 animate-pulse rounded-full bg-gray-500 p-1 text-white">
                                              <svg
                                                xmlns="http://www.w3.org/2000/svg"
                                                viewBox="0 0 20 20"
                                                fill="currentColor"
                                                className="h-3 w-3"
                                              >
                                                <path
                                                  fillRule="evenodd"
                                                  d="M1 5.25A2.25 2.25 0 013.25 3h13.5A2.25 2.25 0 0119 5.25v9.5A2.25 2.25 0 0116.75 17H3.25A2.25 2.25 0 011 14.75v-9.5zm1.5 5.81v3.69c0 .414.336.75.75.75h13.5a.75.75 0 00.75-.75v-2.69l-2.22-2.219a.75.75 0 00-1.06 0l-1.91 1.909.47.47a.75.75 0 11-1.06 1.06L6.53 8.091a.75.75 0 00-1.06 0l-2.97 2.97zM12 7a1 1 0 11-2 0 1 1 0 012 0z"
                                                  clipRule="evenodd"
                                                />
                                              </svg>
                                            </div>
                                          </div>
                                        )}
                                      </div>
                                    )}
                                  </div>

                                  {twitterSize && twitterSize !== 'Perfect' ? (
                                    <AlertBanner
                                      type={'warn'}
                                      layout={'list'}
                                      title={'Headline may be cut off'}
                                      msg1={
                                        'Engagement is higher when readers can see the full image while scrolling'
                                      }
                                      msg2={
                                        twitterSize === 'Too small'
                                          ? 'Try increasing the font size'
                                          : 'Try reducing the font size or re-formatting your post'
                                      }
                                    />
                                  ) : null}
                                  {twitterSize && twitterSize === 'Perfect' ? (
                                    <AlertBanner
                                      type={'success'}
                                      title={
                                        'Image will look great on Twitter!'
                                      }
                                    />
                                  ) : null}

                                  <div className="h-[1px] w-full rounded-full bg-gray-100" />

                                  <div className="flex w-full flex-row items-center justify-between space-x-1 rounded-md py-1 pl-2 pr-1">
                                    <div className="flex flex-row items-center justify-start space-x-1">
                                      <svg
                                        xmlns="http://www.w3.org/2000/svg"
                                        fill="none"
                                        viewBox="0 0 24 24"
                                        strokeWidth={2}
                                        stroke="currentColor"
                                        className="h-4 w-4"
                                      >
                                        <path
                                          strokeLinecap="round"
                                          strokeLinejoin="round"
                                          d="M19.5 14.25v-2.625a3.375 3.375 0 00-3.375-3.375h-1.5A1.125 1.125 0 0113.5 7.125v-1.5a3.375 3.375 0 00-3.375-3.375H8.25m6.75 12l-3-3m0 0l-3 3m3-3v6m-1.5-15H5.625c-.621 0-1.125.504-1.125 1.125v17.25c0 .621.504 1.125 1.125 1.125h12.75c.621 0 1.125-.504 1.125-1.125V11.25a9 9 0 00-9-9z"
                                        />
                                      </svg>

                                      <div className="flex flex-row">
                                        <p className="max-w-[75px] truncate text-sm font-medium text-gray-600 xs:max-w-[150px] md:max-w-[224px]">
                                          {
                                            //headline but replace spaces with dashes
                                            headline
                                              ? headline.replace(/\s/g, '-')
                                              : 'Typeshare-Essay'
                                          }
                                        </p>
                                        <p className="text-sm font-medium text-gray-600">
                                          .jpg
                                        </p>
                                      </div>
                                    </div>

                                    <div className="flex flex-row items-center justify-end space-x-1 text-gray-600">
                                      <div className="flex flex-row space-x-0">
                                        <ButtonTip text={'Decrease Image Size'}>
                                          <button
                                            disabled={imageSize <= 0}
                                            onClick={() =>
                                              decreaseImageSize(imageSize)
                                            }
                                            className="rounded-md p-1 hover:bg-gray-200 disabled:text-gray-300 disabled:hover:bg-transparent"
                                          >
                                            <MinusIcon className={'h-4 w-4'} />
                                          </button>
                                        </ButtonTip>
                                        <ButtonTip text={'Increase Image Size'}>
                                          <button
                                            disabled={imageSize >= 3}
                                            onClick={() =>
                                              increaseImageSize(imageSize)
                                            }
                                            className="rounded-md p-1 hover:bg-gray-200 disabled:text-gray-300 disabled:hover:bg-transparent"
                                          >
                                            <PlusIcon className={'h-4 w-4'} />
                                          </button>
                                        </ButtonTip>
                                      </div>

                                      <ButtonTip text={'Download Image'}>
                                        <button
                                          disabled={
                                            imageLoading || imageNeedsRefresh
                                          }
                                          onClick={() => saveAs()}
                                          className="rounded-md p-1 hover:bg-gray-200 disabled:text-gray-300 disabled:hover:bg-transparent"
                                        >
                                          <svg
                                            xmlns="http://www.w3.org/2000/svg"
                                            viewBox="0 0 20 20"
                                            fill="currentColor"
                                            className="h-4 w-4"
                                          >
                                            <path d="M10.75 2.75a.75.75 0 00-1.5 0v8.614L6.295 8.235a.75.75 0 10-1.09 1.03l4.25 4.5a.75.75 0 001.09 0l4.25-4.5a.75.75 0 00-1.09-1.03l-2.955 3.129V2.75z" />
                                            <path d="M3.5 12.75a.75.75 0 00-1.5 0v2.5A2.75 2.75 0 004.75 18h10.5A2.75 2.75 0 0018 15.25v-2.5a.75.75 0 00-1.5 0v2.5c0 .69-.56 1.25-1.25 1.25H4.75c-.69 0-1.25-.56-1.25-1.25v-2.5z" />
                                          </svg>
                                        </button>
                                      </ButtonTip>

                                      <ButtonTip text={'Change Image Theme'}>
                                        <Link
                                          href={'/theme'}
                                          className="flex cursor-pointer items-center justify-center rounded-md p-1 hover:bg-gray-200"
                                        >
                                          <svg
                                            xmlns="http://www.w3.org/2000/svg"
                                            viewBox="0 0 20 20"
                                            fill="currentColor"
                                            className="h-4 w-4"
                                          >
                                            <path
                                              fillRule="evenodd"
                                              d="M3.5 2A1.5 1.5 0 002 3.5V15a3 3 0 106 0V3.5A1.5 1.5 0 006.5 2h-3zm11.753 6.99L9.5 14.743V6.257l1.51-1.51a1.5 1.5 0 012.122 0l2.121 2.121a1.5 1.5 0 010 2.122zM8.364 18H16.5a1.5 1.5 0 001.5-1.5v-3a1.5 1.5 0 00-1.5-1.5h-2.136l-6 6zM5 16a1 1 0 100-2 1 1 0 000 2z"
                                              clipRule="evenodd"
                                            />
                                          </svg>
                                        </Link>
                                      </ButtonTip>
                                    </div>
                                  </div>
                                </div>
                              )
                            ) : null}
                          </div>

                          <div className="flex w-full flex-col items-start justify-start space-y-2">
                            <div className="flex w-full flex-row items-center justify-between">
                              <div className="flex flex-row items-center justify-center space-x-1 text-gray-600">
                                <MediumLogo className="h-5 w-5 fill-current" />

                                <p className="text-sm font-medium text-gray-600">
                                  Medium
                                </p>
                              </div>

                              {hasMedium ? (
                                mediumSuccess ? (
                                  <CheckCircleIcon className="h-5 w-5 text-orange-500" />
                                ) : mediumScheduling ? (
                                  <SpinnerIcon className="h-5 w-5 animate-spin text-gray-500" />
                                ) : (
                                  <Switch
                                    checked={mediumEnabled}
                                    onChange={() =>
                                      changeShareMedium(!mediumEnabled)
                                    }
                                    className={classNames(
                                      mediumEnabled
                                        ? 'bg-blue-500'
                                        : 'bg-gray-200',
                                      'relative inline-flex h-6 w-11 flex-shrink-0 cursor-pointer rounded-full border-2 border-transparent transition-colors duration-200 ease-in-out focus:outline-none focus:ring-2 focus:ring-indigo-500 focus:ring-offset-2',
                                    )}
                                  >
                                    <span className="sr-only">Use setting</span>
                                    <span
                                      aria-hidden="true"
                                      className={classNames(
                                        mediumEnabled
                                          ? 'translate-x-5'
                                          : 'translate-x-0',
                                        'pointer-events-none inline-block h-5 w-5 transform rounded-full bg-white shadow ring-0 transition duration-200 ease-in-out',
                                      )}
                                    />
                                  </Switch>
                                )
                              ) : (
                                <Button
                                  click={() =>
                                    router.push('/settings/integrations')
                                  }
                                  variant={'outline'}
                                  size={'mini'}
                                >
                                  Connect Medium
                                </Button>
                              )}
                            </div>

                            {mediumEnabled && hasMedium ? (
                              <div className="max-h-80 w-full cursor-pointer items-end justify-end space-y-2 overflow-auto rounded-xl border border-gray-100 bg-white p-3">
                                <MediumStoryPreview
                                  mediumEditorText={mediumHTML}
                                  hasMedium={hasMedium}
                                  mediumProfile={mediumProfile}
                                  headline={headline}
                                />
                              </div>
                            ) : null}
                          </div>

                          <div className="flex w-full flex-col items-start justify-start space-y-2">
                            <div className="flex w-full flex-row items-center justify-between">
                              <div className="flex flex-row items-center justify-center space-x-1.5 text-gray-600">
                                <LinkedInLogo className="h-4 w-4 fill-current" />

                                <p className="text-sm font-medium text-gray-600">
                                  LinkedIn
                                </p>
                              </div>

                              {hasLinkedin && !linkedinExpired ? (
                                linkedinSuccess ? (
                                  <CheckCircleIcon className="h-5 w-5 text-orange-500" />
                                ) : linkedinScheduling ? (
                                  <SpinnerIcon className="h-5 w-5 animate-spin text-gray-500" />
                                ) : (
                                  <Switch
                                    checked={linkedinEnabled}
                                    onChange={() =>
                                      changeShareLinkedIn(!linkedinEnabled)
                                    }
                                    className={classNames(
                                      linkedinEnabled
                                        ? 'bg-blue-500'
                                        : 'bg-gray-200',
                                      'relative inline-flex h-6 w-11 flex-shrink-0 cursor-pointer rounded-full border-2 border-transparent transition-colors duration-200 ease-in-out focus:outline-none focus:ring-2 focus:ring-indigo-500 focus:ring-offset-2',
                                    )}
                                  >
                                    <span className="sr-only">Use setting</span>
                                    <span
                                      aria-hidden="true"
                                      className={classNames(
                                        linkedinEnabled
                                          ? 'translate-x-5'
                                          : 'translate-x-0',
                                        'pointer-events-none inline-block h-5 w-5 transform rounded-full bg-white shadow ring-0 transition duration-200 ease-in-out',
                                      )}
                                    />
                                  </Switch>
                                )
                              ) : linkedinExpired ? (
                                <Button
                                  click={() =>
                                    router.push('/settings/integrations')
                                  }
                                  variant={'secondary'}
                                  size={'mini'}
                                >
                                  Reconnect LinkedIn
                                </Button>
                              ) : (
                                <Button
                                  click={() =>
                                    router.push('/settings/integrations')
                                  }
                                  variant={'outline'}
                                  size={'mini'}
                                >
                                  Connect Linkedin
                                </Button>
                              )}
                            </div>

                            {linkedinEnabled && hasLinkedin ? (
                              <div className="max-h-80 w-full cursor-pointer items-end justify-end space-y-2 overflow-auto rounded-xl border border-gray-100 bg-white p-3">
                                <LinkedinPostPreview
                                  setLinkedinTextReady={setLinkedinTextReady}
                                  hasCustomLinkedinText={hasCustomLinkedinText}
                                  passLinkedinText={updateLinkedinText}
                                  linkedinProfile={linkedinProfile}
                                  linkedinEditorText={linkedinHTML}
                                  twitterType={twitterType}
                                  saveCustomLinkedinText={(val) =>
                                    saveCustomLinkedinText(val)
                                  }
                                  removeCustomLinkedinText={() =>
                                    removeCustomLinkedinText()
                                  }
                                />
                              </div>
                            ) : null}
                          </div>
                        </div>
                      </div>
                      <div className="sticky bottom-0 z-10 flex w-full flex-col items-center justify-center space-y-3 border-t border-gray-100 bg-gray-50 p-4 pt-3">
                        <Tooltip
                          html={
                            <div className="flex flex-col items-start justify-start text-sm font-semibold antialiased">
                              <p className="text-xs text-white">
                                Recommended for accessibility and SEO
                              </p>
                            </div>
                          }
                          position="top"
                          interactive={false}
                          animateFill={false}
                          theme="dark"
                          arrow={true}
                          arrowSize="small"
                          trigger="mouseenter"
                          offset={1}
                          disabled={false}
                        >
                          <div className="relative flex items-start">
                            <div className="flex h-5 items-center">
                              <input
                                id="link-to-blog"
                                aria-describedby="link-to-blog"
                                name="link-to-blog"
                                type="checkbox"
                                checked={attachLink}
                                onChange={() => setAttachLink(!attachLink)}
                                className="h-4 w-4 cursor-pointer rounded-md border-gray-300 text-gray-900 focus:ring-blue-500"
                              />
                            </div>
                            <div className="ml-2 flex flex-col space-y-0 text-sm">
                              <label
                                htmlFor="link-to-blog"
                                className="cursor-pointer font-medium text-gray-700"
                              >
                                Add link to Social Blog at the end of each post?
                              </label>
                            </div>
                          </div>
                        </Tooltip>

                        {!headline &&
                        (twitterType === 'image' || mediumEnabled) ? (
                          <div className="fle-row flex w-full items-center justify-center rounded-lg bg-gray-200/50 p-2 text-center text-sm font-medium text-gray-700">
                            <ExclamationIcon className="mr-1.5 h-4 w-4" />
                            <p>You need a headline</p>
                          </div>
                        ) : null}

                        {slugError ? (
                          <div className="fle-row flex w-full items-center justify-center rounded-lg bg-gray-200/50 p-2 text-center text-sm font-medium text-gray-700">
                            <ExclamationIcon className="mr-1.5 h-4 w-4" />
                            <p>You've already used that post slug</p>
                          </div>
                        ) : null}

                        <div className="flex w-full flex-row items-center justify-center space-x-2">
                          <Button
                            click={() => schedulePost()}
                            loading={scheduling}
                            disabled={
                              scheduling ||
                              (twitterType === 'image'
                                ? (enabled && imageNeedsRefresh) ||
                                  (enabled && imageError) ||
                                  (twitterError && enabled) ||
                                  (enabled && imageLoading)
                                : twitterError && enabled) ||
                              (!headline &&
                              (twitterType === 'image' || mediumEnabled)
                                ? true
                                : false) ||
                              slugError ||
                              (linkedinEnabled && !linkedinTextReady)
                            }
                            width={'full'}
                            size={'mini'}
                            color={'bg-orange-500'}
                          >
                            Schedule
                          </Button>
                        </div>

                        {((twitterError && enabled) || typeshareError) &&
                        errorMSG ? (
                          <div className="flex min-h-[46px] w-full flex-row items-center  justify-between space-x-1 overflow-hidden rounded-lg bg-red-500 p-2 text-sm font-medium text-white">
                            <div className="flex flex-row items-center justify-start space-x-1">
                              <svg
                                xmlns="http://www.w3.org/2000/svg"
                                viewBox="0 0 20 20"
                                fill="currentColor"
                                className="h-4 w-4"
                              >
                                <path
                                  fillRule="evenodd"
                                  d="M18 10a8 8 0 11-16 0 8 8 0 0116 0zm-8-5a.75.75 0 01.75.75v4.5a.75.75 0 01-1.5 0v-4.5A.75.75 0 0110 5zm0 10a1 1 0 100-2 1 1 0 000 2z"
                                  clipRule="evenodd"
                                />
                              </svg>

                              <p>{errorMSG}</p>
                            </div>

                            {needsEditorFix && (
                              <Link
                                href={`/editor/${encodeURIComponent(postID)}`}
                                className="rounded-full border border-white px-3 py-1 text-sm font-medium text-white duration-150 hover:bg-gray-900/10"
                              >
                                Fix in Editor
                              </Link>
                            )}
                          </div>
                        ) : null}
                      </div>
                    </div>
                  </Dialog.Panel>
                </Transition.Child>
              </div>
            </div>
          </div>
        </Dialog>
      </Transition.Root>
    </>
  );
}
